export default __webpack_public_path__ + "static/media/chalet2.8e6ff797.jpg";